module.exports = __webpack_public_path__ + "resources/close-838a56442d38e1bcc35bb65dd10e170f.svg";